var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import clsx from "clsx";
import styles from "./BodyText.module.css";
var BodyText = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.type, type = _b === void 0 ? "span" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, copyColor = _a.copyColor, alignment = _a.alignment, _d = _a.bold, bold = _d === void 0 ? false : _d, props = __rest(_a, ["children", "className", "type", "size", "copyColor", "alignment", "bold"]);
    var Component = type;
    return (_jsx(Component, __assign({ className: clsx(styles.bodyText, size && styles["size-".concat(size)], alignment && styles[alignment], bold && styles.bold, type === "button" && styles.buttonReset, className), style: copyColor ? { color: copyColor } : undefined }, props, { children: children })));
};
export default BodyText;
